{
  "actionbar.actions": "Műveletek",
  "actionbar.actionsAvailable": "Műveletek állnak rendelkezésre.",
  "actionbar.clearSelection": "Kijelölés törlése",
  "actionbar.selected": "{count, plural, =0 {Egy sincs kijelölve} other {# kijelölve}}",
  "actionbar.selectedAll": "Mind kijelölve",
  "button.pending": "függőben levő",
  "contextualhelp.help": "Súgó",
  "contextualhelp.info": "Információ",
  "dialog.alert": "Figyelmeztetés",
  "dialog.dismiss": "Elutasítás",
  "dropzone.replaceMessage": "Ejtse le a fájlt a cseréhez",
  "inlinealert.informative": "Információ",
  "inlinealert.negative": "Hiba",
  "inlinealert.notice": "Figyelmeztetés",
  "inlinealert.positive": "Siker",
  "label.(optional)": "(opcionális)",
  "label.(required)": "(kötelező)",
  "menu.moreActions": "További lehetőségek",
  "picker.placeholder": "Kiválasztás…",
  "slider.maximum": "Maximum",
  "slider.minimum": "Minimum",
  "table.loading": "Betöltés folyamatban…",
  "table.loadingMore": "Továbbiak betöltése folyamatban…",
  "table.resizeColumn": "Oszlop átméretezése",
  "table.sortAscending": "Növekvő rendezés",
  "table.sortDescending": "Csökkenő rendezés",
  "tag.actions": "Műveletek",
  "tag.hideButtonLabel": "Mutass kevesebbet",
  "tag.noTags": "Egyik sem",
  "tag.showAllButtonLabel": "Az összes megjelenítése ({tagCount, number})",
  "breadcrumbs.more": "További elemek"
}